<script lang="ts">
    import PageWrapper from '$lib/components/_page/PageWrapper.svelte';
</script>

<PageWrapper pageMaxWidth={930}
             footer={true}
>
    <slot/>
</PageWrapper>
